import request from '@/utils/request'

// 导航栏
export function NavgetList(data){
    return request({
        method:'get',
        url:'Navbar/getList',
        params:data
    })
}


// WEBPACK FOOTER //
// ./src/api/Navbar.js